<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <path
      d="M11.62 16.24a1.9 1.9 0 10-1.9-1.9 1.91 1.91 0 001.9 1.9zm5.71-8.57h-.95v-1.9a4.76 4.76 0 10-9.52 0v1.9H5.9A1.91 1.91 0 004 9.57v9.53A1.91 1.91 0 005.9 21h11.43a1.91 1.91 0 001.9-1.9V9.57a1.91 1.91 0 00-1.9-1.9zm-8.66-1.9a2.95 2.95 0 015.9 0v1.9h-5.9zm8.66 13.33H5.9V9.57h11.43z"
      fill="currentColor"
    />
  </g>
</template>
